var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import { GoogleTagManager } from './GoogleTagManager';
import { LinkedinInsight } from './LinkedinInsight';
import { Metrics } from './Metrics';
import { Status } from './util';
/**
 * AnalyticsScriptLoader is used to load any scripts containing cookies which require user consent before they can be set
 * This way we block the use of the cookies until the user has given consent
 */
export var AnalyticsScriptLoader = function () {
    var _a = __read(React.useState(''), 2), currentConcents = _a[0], setCurrentConcents = _a[1];
    React.useEffect(function () {
        var handleConsentChange = function (e) {
            if (e.data === Status.WaitingForConsent) {
                window.OneTrust.OnConsentChanged(function () {
                    setCurrentConcents(window.OnetrustActiveGroups);
                });
            }
            else if (e.data === Status.ConsentExpressed) {
                setCurrentConcents(window.OnetrustActiveGroups);
            }
        };
        window.addEventListener('message', handleConsentChange, false);
        return function () {
            window.removeEventListener('message', handleConsentChange, false);
        };
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(Metrics, { currentConcents: currentConcents }),
        React.createElement(GoogleTagManager, { currentConcents: currentConcents }),
        React.createElement(LinkedinInsight, { currentConcents: currentConcents })));
};
